import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HighLogo from "../../components/HighLogo";
import logo from "../../../assets/logo.png";

const HEADER_OFFSET = 80;

const HelpSupportStart: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Jump with sticky-header offset so titles stay visible
  const jumpTo = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;

  el.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};


  return (
    <div style={shell}>
      {/* Top Bar */}
      <header style={header}>
       <div onClick={() => navigate("/gallery")} style={{ cursor: "pointer" }}>
  <HighLogo
    src={logo}
    style={{ width: 100, display: "block", marginLeft: "-20px", marginTop: "6px" }}
    padding={0}
    onClick={() => navigate("/gallery")}
  />
</div>
      </header>

      <main style={main}>
        {/* Page Intro */}
        <section style={intro}>
          <h1 style={h1}>{t("help.start.title", "Help & Support")}</h1>
          <p style={subhead}>
            {t(
              "help.start.subtitle",
              "Find guides, FAQs, and ways to get help."
            )}
          </p>
        </section>

        {/* Jump Links */}
        <nav style={jumpNav}>
          {[
            ["account", "Account Guide"],
            ["platform", "Platform Guide"],
            ["ads", "Advertisement Guide"],
            ["faq", "FAQ"],
          ].map(([id, label]) => (
            <button
              key={id}
              onClick={() => jumpTo(id)}
              style={jumpBtn}
            >
              {label}
            </button>
          ))}
        </nav>

        {/* ACCOUNT */}
        <Section
          id="account"
          title="Account Guide"
          subtitle="Registration, login & account settings"
          basePath="/help/account"
          bullets={[
            ["Intro", "/help/account#intro"],
            ["Registration", "/help/account#registration"],
            ["Login", "/help/account#login"],
            ["Forgot password", "/help/account#forgot-password"],
            ["Security", "/help/account#security"],
            ["Privacy & data", "/help/account#data-privacy"],
          ]}
          navigate={navigate}
        />

        {/* PLATFORM */}
        <Section
          id="platform"
          title="Platform Guide"
          subtitle="How UNYDO works"
          basePath="/help/platform"
          bullets={[
            ["Gallery", "/help/platform#gallery"],
            ["Preferences", "/help/platform#preferences"],
            ["My Likes", "/help/platform#mylikes"],
            ["Upload a post", "/help/platform#uploadPost"],
            ["My profile", "/help/platform#myProfile"],
            ["Followers & following", "/help/platform#followersFollowing"],
          ]}
          navigate={navigate}
        />

        {/* ADS */}
        <Section
          id="ads"
          title="Advertisement Guide"
          subtitle="Ads, budgets, pricing & billing"
          basePath="/help/advertisement"
          bullets={[
            ["Create an ad", "/help/advertisement#creating-an-ad"],
            ["Targeting", "/help/advertisement#targeting"],
            ["Budgets", "/help/advertisement#budgets"],
            ["Pricing", "/help/advertisement#pricing"],
            ["Moderation", "/help/advertisement#moderation"],
          ]}
          navigate={navigate}
        />

        {/* FAQ */}
        <Section
          id="faq"
          title="FAQ"
          subtitle="Quick answers by topic"
          basePath="/help/faq"
          bullets={[
            ["Posting & gallery", "/help/faq#posting-gallery"],
            ["Location & privacy", "/help/faq#location-privacy"],
            ["Chat & security", "/help/faq#chat-encryption"],
            ["Ads & billing", "/help/faq#ads-billing"],
            ["Troubleshooting", "/help/faq#troubleshooting"],
          ]}
          navigate={navigate}
        />

        {/* CONTACT */}
        <section style={contact}>
          <h2 style={sectionTitle}>Contact Support</h2>
          <p style={sectionHint}>
            Need more help? Reach out to our support team.
          </p>
          <button
            style={ctaBtn}
            onClick={() => navigate("/help/contact")}
          >
            Contact Support →
          </button>
        </section>
      </main>
    </div>
  );
};

export default HelpSupportStart;

/* ------------------------------------------------------------------ */

const Section = ({
  id,
  title,
  subtitle,
  bullets,
  navigate,
  basePath,
}: any) => (
  <section id={id} style={{ ...section, scrollMarginTop: HEADER_OFFSET }}>
    <button
      onClick={() => navigate(basePath)}
      style={sectionTitleBtn}
    >
      {title}
    </button>
    <p style={sectionHint}>{subtitle}</p>

    <div style={card}>
      {bullets.map(([label, to]: any) => (
        <button
          key={to}
          onClick={() => navigate(to)}
          style={bullet}
        >
          • {label}
        </button>
      ))}
    </div>
  </section>
);

/* ----------------- styles ----------------- */

const shell = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top, #020617 0, #000 45%, #020617 100%)",
  color: "#f9fafb",
};

const header = {
  position: "sticky" as const,
  top: 0,
  zIndex: 20,
  padding: "12px 16px",
  background: "rgba(2,6,23,0.92)",
  backdropFilter: "blur(10px)",
  borderBottom: "1px solid rgba(148,163,184,0.2)",
};

const main = {
  padding: "20px 16px 90px",
};

const intro = { marginBottom: 20 };

const h1 = {
  fontSize: 28,
  margin: 0,
  letterSpacing: -0.03,
};

const subhead = {
  marginTop: 8,
  fontSize: 15,
  color: "#9ca3af",
};

const jumpNav = {
  display: "flex",
  gap: 10,
  overflowX: "auto" as const,
  marginBottom: 24,
};

const jumpBtn = {
  padding: "8px 14px",
  borderRadius: 999,
  border: "1px solid #4b5563",
  background: "transparent",
  color: "#e5e7eb",
  fontSize: 13,
  whiteSpace: "nowrap" as const,
};

const section = { marginBottom: 32 };

const sectionTitle = {
  fontSize: 20,
  fontWeight: 800,
};

const sectionTitleBtn = {
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  fontSize: 20,
  fontWeight: 800,
  color: "#f9fafb",
  textAlign: "left" as const,
  cursor: "pointer",
};

const sectionHint = {
  marginTop: 6,
  fontSize: 14,
  color: "#9ca3af",
};

const card = {
  marginTop: 12,
  borderRadius: 18,
  border: "1px solid rgba(148,163,184,0.25)",
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.95), rgba(3,7,18,1))",
  padding: 14,
  display: "grid",
  gap: 10,
};

const bullet = {
  background: "transparent",
  border: "none",
  textAlign: "left" as const,
  fontSize: 15,
  color: "#cbd5e1",
  cursor: "pointer",
};

const contact = {
  marginTop: 40,
  padding: 16,
  borderRadius: 20,
  border: "1px solid rgba(148,163,184,0.22)",
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.85), rgba(3,7,18,1))",
};

const ctaBtn = {
  marginTop: 14,
  width: "100%",
  padding: "14px",
  borderRadius: 999,
  border: "none",
  background: "linear-gradient(135deg,#22c55e,#a3e635)",
  fontWeight: 900,
  fontSize: 15,
  cursor: "pointer",
};
